import { Stack, Typography, Link } from "@mui/material";
import { useTranslation } from "react-i18next";
import "./MyPassword.scss";
import {
  PasswordInputsData,
  Passwords,
} from "../../core/models/myPassword/myPassword.model";
import { useContext, useState } from "react";
import ButtonElement from "../UI/ButtonElement/ButtonElement";
import AlertComponent from "../UI/AlertComponent/AlertComponent";
import { loginPost } from "../../core/services/login/login.service";
import { changePassword as changePasswordFetch } from "../../core/services/myPassword/myPassword.service";
import { useNavigate } from "react-router-dom";
import TotalEnergiesContext from "../../core/store/context/TotalEnergiesContext";
import { UserData } from "../../core/models/login/login.model";
import { FormattedOwnerData } from "../../core/models/ownerData/ownerData.model";

interface MyPasswordProps {
  handleGoBackClick?: () => void;
  setIsMyPasswordSuccessfull?: React.Dispatch<React.SetStateAction<boolean>>;
}

const MyPassword = ({
  handleGoBackClick,
  setIsMyPasswordSuccessfull,
}: MyPasswordProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { ownerData, userData, storageUserData } =
    useContext(TotalEnergiesContext);
  const [passwords, setPasswords] = useState<Passwords>({
    currentPassword: "",
    newPassword: "",
    repeatNewPassword: "",
  });
  const [isError, setIsError] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);

  const passwordInputsData: PasswordInputsData[] = [
    {
      id: "currentPassword",
      label: "Contraseña actual",
    },
    {
      id: "newPassword",
      label: "Nueva contraseña",
    },
    {
      id: "repeatNewPassword",
      label: "Repetir nueva contraseña",
    },
  ];

  const changePassword = (
    userData: UserData,
    ownerData: FormattedOwnerData
  ): Promise<void> | void =>
    loginPost({
      user: userData.user,
      password: passwords.currentPassword,
    })
      .then(async () => {
        await changePasswordFetch(userData, passwords.newPassword, ownerData);
        const response = await loginPost({
          user: userData.user,
          password: passwords.newPassword,
        });
        storageUserData({ ...response, user: userData.user });
        setIsMyPasswordSuccessfull
          ? setIsMyPasswordSuccessfull(true)
          : navigate(process.env.REACT_APP_CHANGE_PASSWORD_SUCCESS!);
      })
      .catch((error) => {
        setErrorMessage("La contraseña actual es incorrecta");
        setIsError(true);
      });

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const { id, value } = event.target;
    setPasswords((prevPasswords) => ({ ...prevPasswords, [id]: value }));
  };

  const handleSubmit = async (event: React.FormEvent): Promise<void> => {
    event.preventDefault();
    setIsLoading(true);
    setIsError(false);
    if (
      passwordInputsData.some(({ id }) => !passwords[id].length) ||
      passwords.newPassword !== passwords.repeatNewPassword
    ) {
      setIsError(true);
      setIsLoading(false);
      setErrorMessage("Las contraseñas deben coincidir");
      return;
    }

    if (!userData || !ownerData) {
      setIsError(true);
      setIsLoading(false);
      return;
    }

    changePassword(userData, ownerData);
  };

  return (
    <Stack className="my-password">
      <Link
        className="my-personal-data__button"
        component="button"
        underline="none"
        onClick={handleGoBackClick}
        sx={{ marginBottom: { xs: "56px", lg: 5 }, paddingY: "14px" }}
      >
        {" "}
        <Typography
          component="span"
          className="t-icon-long-arrow-left"
          aria-hidden="true"
          paddingRight={"10px"}
        />
        {t("Botón volver")}
      </Link>
      <Typography
        component="h3"
        variant="h3"
        sx={{ paddingBottom: { xs: "40px", headerMobile: "46px" } }}
      >
        <span
          className="t-icon-lock brand-red"
          style={{ paddingRight: "15px" }}
        />{" "}
        {t("Header.Perfil.Contraseña")}
      </Typography>
      {isError && (
        <AlertComponent onClick={() => setIsError(false)}>
          {t(`Mi contraseña.${errorMessage}`)}
        </AlertComponent>
      )}
      <form action="" id="my-password" method="post" onSubmit={handleSubmit}>
        {passwordInputsData.map(({ id, label }) => (
          <Stack key={id} direction="column" paddingBottom="2rem">
            <label htmlFor={id}>
              {" "}
              {t(`Mi contraseña.${label}`)} <span className="brand-red">*</span>
            </label>
            <input
              width="100%"
              type="password"
              name={id}
              id={id}
              data-testid={id}
              value={passwords[id]}
              onChange={handleChange}
            />
          </Stack>
        ))}
        <ButtonElement modal isLoading={isLoading}>
          {t("Mi contraseña.Cambiar contraseña")}
        </ButtonElement>
      </form>
    </Stack>
  );
};

export default MyPassword;
